import { Injectable } from "@angular/core";
import { dataTable } from "src/helper/dataTable";
// import { dataTable } from './helper/dataTable';

@Injectable({
  providedIn: "root",
})
export class FilterRecorderService {
  private filterActiveSet = new Set();
  private rowData: dataTable[] = new Array();
  private cellDirectlyChanged = 0;
  customUndoStack = new Array();
  customRedoStack = new Array();
  prevModel = {};
  currentModel = {};
  previous = {};
  prevStore = {};
  lastCalledFunction: any;
  conversionDictionary: any = {
    sku: "SKU",
    re: "Retail Env",
    format: "Format",
    prod_desc: "Prod Desc.",
    mnfctr_nm: "Mfr",
    brand_nm: "Brand",
    sub_brand_nm: "Sub-Brand",
    typ_pk_nm: "Pack Type",
    wgt: "Weight(grams)",
    seg_nm: "Segment",
    sub_seg_nm: "Sub-Segment",
    sku_desc: "SKU Name",
    volume_kg: "Volume",
    price: "Base Price",
    next_price: "Next Price",
    scenario_price: "Scenario Price",
    group: "Group",
  };
  // ['retailer','Category','BrandPackVariant','PriceSector','TarLevel','Base_Price','BrandHouse']
  // ["retailer","Category","BrandPackVariant","PriceSector","TarLevel","Base_Price","BrandHouse"]

  constructor() {}

  updateCurrentModel(model: any) {
    this.currentModel = { ...model };
    this.prevModel = { ...model };
  }

  filterUndo(model: any, column: any) {
    const stacktop = this.customUndoStack.pop();
    this.customUndoStack.push(stacktop);
    var localModel = Object.create(stacktop["model"]);
    localModel[column] = model;

    this.undoStackPusher(
      stacktop["inflation"],
      stacktop["demoniation"],
      stacktop["absolute"],
      stacktop["percent"],
      stacktop["scenarioP"],
      localModel,
      6,
    );
    this.prevModel = { ...this.currentModel };
  }

  undoStackPusher(
    inflation: any,
    demoniation: any,
    absolute: any,
    percent: any,
    scenarioP: any,
    model: any,
    lastCalledFunction: any,
  ) {
    this.lastCalledFunction = lastCalledFunction;
    this.customUndoStack.push({
      inflation: inflation,
      demoniation: demoniation,
      absolute: absolute,
      percent: percent,
      scenarioP: scenarioP,
      model: model,
      last: lastCalledFunction,
    });
  }

  getLastCalledFunction() {
    return this.lastCalledFunction;
  }

  setLastCalledFunction(func: any) {
    this.lastCalledFunction = func;
  }

  getUndoStack() {
    return this.customUndoStack;
  }

  clearUndoStack() {
    this.customUndoStack = [];
  }

  getUndoStackSize() {
    return this.customUndoStack.length;
  }

  deleteFilterColumn(filterColumn: string) {
    this.filterActiveSet.delete(filterColumn);
  }
  addFilterColumn(filterColumn: string) {
    this.filterActiveSet.add(filterColumn);
  }

  getActiveFilter() {
    var filters: any = Array.from(this.filterActiveSet.values());
    var convertedArray = [];
    var len = filters.length;
    for (var i = 0; i < len; i++) {
      var a = filters[i];
      convertedArray.push(this.conversionDictionary[a]);
    }

    return convertedArray;
  }

  setRowData(rowData: dataTable[]) {
    this.rowData = [];
    this.rowData = rowData;
  }

  getRowData() {
    return this.rowData;
  }

  isCellDirectlyChanged() {
    let temp = this.cellDirectlyChanged;
    this.cellDirectlyChanged = 0;
    return temp;
  }

  recordCellData() {
    this.cellDirectlyChanged = 1;
  }
}
